var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content change-charge-verify" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_All"),
                  name: "tabAll",
                  lazy: true
                }
              },
              [
                _c("tab-change-charge-bpm", {
                  attrs: { "application-status": 0 }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Processing"),
                  name: "tabDo",
                  lazy: true
                }
              },
              [
                _c("tab-change-charge-bpm", {
                  attrs: { "application-status": 1 }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_Approval"),
                  name: "done",
                  lazy: true
                }
              },
              [
                _c("tab-change-charge-bpm", {
                  attrs: { "application-status": 2 }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }